export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20digital%20illustration%20of%20vibrant%20warm%20gradient%20waves%20with%20floating%20social%20media%20icons%20and%20notification%20bubbles%2C%20modern%20clean%20aesthetic%2C%20coral%20and%20amber%20color%20palette%2C%20editorial%20tech%20news%20design%2C%20subtle%20geometric%20patterns%2C%20soft%20atmospheric%20lighting%2C%20digital%20era%20visual%20metaphor%2C%20smooth%20flowing%20shapes%2C%20no%20text%20no%20letters%2C%20abstract%20data%20streams%2C%20warm%20energy%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="今日吃瓜背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-label font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              每日必吃 · 实时更新
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-4">
              今日吃瓜
              <span className="block text-lg md:text-xl lg:text-2xl font-body font-light mt-2 text-background-50/85">
                热门大瓜一站式追踪
              </span>
            </h1>

            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              全网热点事件实时汇总平台，覆盖娱乐圈、网红圈、社会热点等多元领域。
              每天追踪最新最热的大瓜事件，多维度整理与呈现，
              让你不错过任何一个值得关注的今日吃瓜热点。当前重点聚焦暑期档娱乐动态与热播综艺背后的精彩话题。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2 text-background-50/90">
                <span className="text-lg md:text-xl font-heading text-accent-300">500+</span>
                <span className="text-xs md:text-sm text-background-50/70">每日热度话题</span>
              </div>
              <div className="w-px h-5 bg-background-50/20 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-background-50/90">
                <span className="text-lg md:text-xl font-heading text-accent-300">20+</span>
                <span className="text-xs md:text-sm text-background-50/70">平台热点覆盖</span>
              </div>
              <div className="w-px h-5 bg-background-50/20 hidden sm:block"></div>
              <div className="flex items-center gap-2 text-background-50/90">
                <span className="text-lg md:text-xl font-heading text-accent-300">7×24h</span>
                <span className="text-xs md:text-sm text-background-50/70">不间断追踪</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-label font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-eye-line"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/30 text-background-50 font-label text-sm hover:bg-background-50/10 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[260px] h-[260px] md:w-[380px] md:h-[380px] lg:w-[420px] lg:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20vibrant%20watermelon%20sliced%20open%20revealing%20glowing%20news%20icons%20and%20trending%20symbols%20inside%2C%20modern%20minimalist%20style%2C%20coral%20red%20and%20warm%20amber%20color%20palette%2C%20clean%20white%20background%2C%20editorial%20illustration%20with%20playful%20chinese%20internet%20culture%20aesthetic%2C%20soft%20shadows%2C%20contemporary%20graphic%20design%2C%20no%20text%20no%20letters&width=800&height=800&seq=hero-main-2026&orientation=squarish"
                alt="今日吃瓜主视觉"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}